/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'
import { RENT_LINX_PLUS } from '../../../../shared/constants/source'

export const isPhoneRequired = (item: Listable | Property | Pin) => {
  return (
    item.feedName === RENT_LINX_PLUS || !!item.features?.includes(PropertyFeatures.REQ_PHONE_NUMBER)
  )
}
